import React from 'react'

const DEFAULT_HEIGHT = 100

// Renders the tenant logo (a JPEG or PNG) as a plain <img>. It used to wrap the file in an
// <svg width="100%"><image/></svg>, which has no width of its own: inside a shrink-to-fit
// parent such as the sidebar's logo link, Safari resolved that 100% to 0 and the logo
// vanished, while Chrome fell back to 300px. An <img> takes its width from the file.
const ImageToSvgConverter = ({ imageString, height = DEFAULT_HEIGHT }: { imageString: string; height?: number }) =>
  imageString ? (
    <img
      data-testid="tenant-logo"
      src={imageString}
      alt=""
      style={{ display: 'block', margin: 'auto', height, maxWidth: '100%', objectFit: 'contain' }}
    />
  ) : null

export default ImageToSvgConverter
